module.exports = __webpack_public_path__ + "img/20200514_151820.7866ef6d.jpg";